import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getProductHourData } from '@/service/production/proReportAggregate';
export default function useHourData(params) {
  var hourData = ref([]);
  // 获取主机汇总数据
  var getProductHourDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getProductHourData(params.value);
          case 2:
            data = _context.sent;
            if (data) {
              hourData.value = data.list;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getProductHourDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var hourDataTotal = computed(function () {
    var lineData = hourData.value.map(function (item) {
      return item.net_weight;
    });
    var xLabels = hourData.value.map(function (item) {
      return item.hour_time;
    });
    var legendData = ['时产'];
    return {
      xLabels: xLabels,
      lineData: lineData,
      legendData: legendData,
      legendShow: false,
      color: 'rgba(255,255,255,0.6)',
      height: '150px',
      grid: {
        left: 50,
        top: 10,
        bottom: 30,
        right: 20
      },
      labelColor: 'rgba(255, 255, 255, 0.5)',
      splitLineColor: ['rgba(255, 255, 255, 0.2)'],
      splitLineType: 'dashed',
      showBackground: false,
      customTooltip: true,
      formatter: function formatter(params) {
        var res = "\n            <div >\n              <div class=\"flex align-center\">\n                <span class=\"ml-2\">".concat(params[0].axisValue, "</span>\n              </div>\n            ");
        params.forEach(function (item) {
          res += "\n              <div >\n                ".concat(item.marker, "\n                <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "\u5428</span>\n              </div>\n            ");
        });
        res += '</div>';
        return res;
      }
    };
  });
  return [hourDataTotal, getProductHourDataAsync];
}